import { ScoreCategories, ScoreCategoryType } from '../score-category.type';

export function isScoreFilterCategory(value: any): value is ScoreCategoryType {
  return ScoreCategories.includes(value);
}
